import type { FaireProductEntity } from "../../entity_types/product";

export const p_2p9kxdxkwa: FaireProductEntity = {
  token: "p_2p9kxdxkwa",
  type: "product",
  name: "Mountain Lavender Vegan & Sensitive Plastic Free Deodorant",
  brandToken: "b_axtc527c9j",
  brandName: "Humble Brands, Inc.",
  imageUrl:
    "https://cdn.faire.com/fastly/f511e4a748d1f220531718ab4172d9e07e850a66779a9166133e8e84b1582236.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/79fd7b25691fad32be0c17c1b62b17578d53ad99a468288a1482ac26f4131010.jpeg",
    "https://cdn.faire.com/fastly/0d9d72dbfa1a0eebe15c48e4d93f1248a032478c58e5974c041fc7e90c51a1cf.jpeg",
    "https://cdn.faire.com/fastly/fdfa3bb2501a733b89ea6744c4ea178b2c00de82071246fac48262094b86eb5a.jpeg",
    "https://cdn.faire.com/fastly/7e066fa3ffbf3440b2971317be64ef1568a011f71a2e1d5542a51db7fed0ca7e.jpeg",
    "https://cdn.faire.com/fastly/0cdb39ed9fa71b858db1dc9164fbbb574c5a82b73c07fb1f392dae1e65bfa248.jpeg",
    "https://cdn.faire.com/fastly/1bed2ba9777aea553ba406c8fab717dc3ccf13c8fc12d661f787a24e1a99ab97.jpeg",
  ],
  priceDollars: 8.99,
  description:
    "Scent Note: Full-bodied, Sweet, and Herbaceous\n\nProduct Description: Made with simple, highly effective ingredients (MCT oil, non-GMO corn starch, beeswax, baking soda and botanically-based scents). Humble Brands Deodorant is formulated to absorb and neutralize body odor and has no aluminum, alcohol, dyes, parabens, sulfates or artificial fragrance. From the paperboard packaging to the ink and lining, Humble’s plastic-free deodorant will biodegrade in 2-5 months and is recyclable. Certified Cruelty-Free by Leaping Bunny and a 1% for the Planet product that gives back with every purchase.\n\nSize: 2.65 oz. / 75g",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:05.208Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
